import { Settings } from '@/features/settings/components/templates';

export const SettingsContainer = () => {
  return <Settings />;
};
